import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'kt-etapeinstruction',
  templateUrl: './etapeinstruction.component.html',
  styleUrls: ['./etapeinstruction.component.scss']
})
export class EtapeinstructionComponent implements OnInit {

  instruction: any;
  iddossier: any;
  selectedInstructeur: any;
  comment: any;
  private debounce: Subject<string> = new Subject();
  
  constructor(
    public dialogRef: MatDialogRef<EtapeinstructionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private changeDetectorRef : ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.instruction = this.data.instruction;
    if(this.instruction && this.instruction.comment)
      this.comment = this.instruction.comment;
    this.iddossier = this.data.iddossier;
    if(this.instruction.type && this.instruction.type.professions && this.data.iddossier){
      let professions = [];
      this.instruction.type.professions.forEach(element => {
        professions.push(element.key);
      });
      
     let onlyzone:boolean=false;
    if (this.instruction.type.zone!=undefined)
       onlyzone=this.instruction.type.zone;
       let currentID:number=undefined;
                
      if (this.instruction.instructeur!=undefined &&  this.instruction.instructeur.ID!=undefined)
               currentID=  this.instruction.instructeur.ID;   
      this.appService.getUsersByProfressions(professions,this.iddossier,null,onlyzone,currentID).subscribe((res) => {
        console.log(res);
        this.instruction.possibleTiers = res.result;
        
                    let grp:any={};
            this.instruction.possibleGroupTiers=[];
            this.instruction.possibleTiers.forEach((r: any) => {
				if (grp[""+r.sameZone]==undefined) {
						  grp[""+r.sameZone]={
							   label:r.tiersZone,
							   tiers:[],
							   ordre:r.sameZone
						   };
				}
				grp[""+r.sameZone].tiers.push(r);
			});	
			let grps:any[]=[];
			let keys:any[]=Object.keys(grp).sort((a,b) => ( a > b) ? -1:1);
			console.log("group getUsersByProfressions ajax",keys,grp)
			for (let i = 0; i <keys.length; i++) {
				grps.push(grp[keys[i]]);
			}	
			//grp.reverse();
			this.instruction.possibleGroupTiers=grps;//.sort((a,b) => ( a.ordre > b.ordre) ? 1:-1);
			console.log("group getUsersByProfressions",grps);
        
        
        if(this.instruction && this.instruction.possibleTiers){
          this.instruction.possibleTiers.forEach(element => {
            if(this.instruction.instructeur.ID === element.ID)
            this.instruction.selectedTier = element;
          });
        }
        this.changeDetectorRef.detectChanges();
      });

      this.debounce.pipe(
        debounceTime(1000)
      ).subscribe(search => {
        if(search.length > 0){
          this.appService.getUsersByProfressions(professions,this.iddossier, search,onlyzone,currentID).subscribe((result) => {
            this.instruction.possibleTiers = result.result;
            
            let grp:any={};
            this.instruction.possibleGroupTiers=[];
            this.instruction.possibleTiers.forEach((r: any) => {
				if (grp[""+r.sameZone]==undefined) {
						  grp[""+r.sameZone]={
							   label:r.tiersZone,
							   tiers:[],
							   ordre:r.sameZone
						   };
				}
				grp[""+r.sameZone].tiers.push(r);
			});	
			let grps:any[]=[];
			let keys:any[]=Object.keys(grp).sort((a,b) => ( a > b) ? -1:1);
			console.log("group getUsersByProfressions ajax",keys,grp)
			for (let i = 0; i <keys.length; i++) {
				grps.push(grp[keys[i]]);
			}	
			//grp.reverse();
			this.instruction.possibleGroupTiers=grps;//.sort((a,b) => ( a.ordre > b.ordre) ? 1:-1);
			console.log("group getUsersByProfressions",grps);
            
            
            this.changeDetectorRef.detectChanges();
          });
        }
  
      });
    }
  }

  
  displayAutoSelectListInstru(key?: any): string | undefined {
    let selected;
    if(this.instruction && this.instruction.possibleTiers){
      this.instruction.possibleTiers.forEach((select) => {
        if(key && select.ID === key.ID)
          selected = select;
      })
    }
    return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : ''): undefined;
  }
  
  triggerAutocompSelectionList(search: any) {
    this.debounce.next(search);
  }

  changeEtape(etape: any){
    if(this.instruction && this.instruction.selectedTier && !this.selectedInstructeur){
      this.selectedInstructeur = this.instruction.selectedTier;
    }
    console.log(this.instruction, this.selectedInstructeur, this.comment, etape);
    let dataReturn = {
      instructeur : this.selectedInstructeur,
      comment: this.comment,
      etape: etape
    }
    this.dialogRef.close(dataReturn);
  }
}
